import {
  InfiniteData,
  MutationOptions,
  UseMutationOptions,
} from "@tanstack/react-query";
import {
  useAuthInfiniteQuery,
  useAuthMutation,
  UseInfiniteQueryExtendedOptions,
} from "@bn/api";
import {
  BookingsApiListAndSearchAllBookingsRequest,
  CACHE_KEYS,
  listAndSearchAllBookings,
  PageableBookingList,
} from "@bn/api/apiv1";
import {
  deleteBooking,
  downloadBookings,
  GetBookingParams,
} from "@api/v1/methods";

export const useDownloadBookings = (
  params: GetBookingParams,
  options?: UseMutationOptions<Blob, AxiosApiError, unknown>
) => useAuthMutation((token) => downloadBookings(token, params), options);

export const useDeleteBooking = (
  options: MutationOptions<unknown, AxiosApiError, unknown> = {}
) => useAuthMutation(deleteBooking, options);

export const useInfiniteListAndSearchAllBookings = (
  params?: BookingsApiListAndSearchAllBookingsRequest,
  options?: UseInfiniteQueryExtendedOptions<
    PageableBookingList,
    AxiosApiError,
    InfiniteData<PageableBookingList>
  >
) => {
  return useAuthInfiniteQuery(
    [CACHE_KEYS.LIST_AND_SEARCH_ALL_BOOKINGS, "infinite", params],
    ({ token, pageParam }) =>
      listAndSearchAllBookings(token, {
        ...params,
        page: (pageParam as number) || 1,
      }),
    options
  );
};
